/**
 * avatars/items/horns.js
 * Xây dựng hình học 3D cho createHorns
 */

import * as THREE from 'three';
import { HORN_TYPES } from './item-types.js';

export { HORN_TYPES };

export function createHorns(lib, type, headSize, hornColor = '#ea580c') {
  const hornGroup = new THREE.Group();
  hornGroup.name = `Horns_${type}`;

  if (!type || type === 'none') return hornGroup;

  const baseMat = new THREE.MeshStandardMaterial({
    color: hornColor,
    roughness: 0.5,
    metalness: 0.2
  });
  lib.disposables.push(baseMat);

  if (type === 'devil_horns') {
    // ĐÔI SỪNG QUỶ NHAM THẠCH CONG VỂNH VỀ TRƯỚC
    [-1, 1].forEach((side) => {
      const baseGeo = new THREE.BoxGeometry(headSize * 0.16, headSize * 0.26, headSize * 0.16);
      const base = new THREE.Mesh(baseGeo, baseMat);
      base.position.set(side * headSize * 0.36, headSize * 1.05, headSize * 0.15);
      base.rotation.set(0.2, 0, -side * 0.35);
      hornGroup.add(base);

      const midGeo = new THREE.BoxGeometry(headSize * 0.12, headSize * 0.24, headSize * 0.12);
      const mid = new THREE.Mesh(midGeo, baseMat);
      mid.position.set(side * headSize * 0.44, headSize * 1.24, headSize * 0.22);
      mid.rotation.set(0.4, 0, -side * 0.55);
      hornGroup.add(mid);

      const tipGeo = new THREE.BoxGeometry(headSize * 0.08, headSize * 0.2, headSize * 0.08);
      const tip = new THREE.Mesh(tipGeo, baseMat);
      tip.position.set(side * headSize * 0.5, headSize * 1.4, headSize * 0.3);
      tip.rotation.set(0.6, 0, -side * 0.7);
      hornGroup.add(tip);

      lib.disposables.push(baseGeo, midGeo, tipGeo);
    });
  } else if (type === 'dragon_horns') {
    // ĐÔI SỪNG RỒNG NHIỀU BẬC CONG VUỐT VỀ SAU GÁY
    [-1, 1].forEach((side) => {
      const g1 = new THREE.BoxGeometry(headSize * 0.16, headSize * 0.22, headSize * 0.18);
      const m1 = new THREE.Mesh(g1, baseMat);
      m1.position.set(side * headSize * 0.3, headSize * 1.05, -headSize * 0.08);
      m1.rotation.set(-0.35, side * 0.15, -side * 0.25);
      hornGroup.add(m1);

      const g2 = new THREE.BoxGeometry(headSize * 0.13, headSize * 0.28, headSize * 0.14);
      const m2 = new THREE.Mesh(g2, baseMat);
      m2.position.set(side * headSize * 0.38, headSize * 1.18, -headSize * 0.28);
      m2.rotation.set(-0.65, side * 0.2, -side * 0.35);
      hornGroup.add(m2);

      const g3 = new THREE.BoxGeometry(headSize * 0.09, headSize * 0.26, headSize * 0.09);
      const m3 = new THREE.Mesh(g3, baseMat);
      m3.position.set(side * headSize * 0.44, headSize * 1.3, -headSize * 0.5);
      m3.rotation.set(-0.9, side * 0.25, -side * 0.4);
      hornGroup.add(m3);

      lib.disposables.push(g1, g2, g3);
    });
  } else if (type === 'crystal_horns') {
    // CỤM GAI TINH THỂ THẠCH ANH NHỌN HOẮT
    const crystalMat = new THREE.MeshStandardMaterial({
      color: hornColor,
      roughness: 0.15,
      metalness: 0.85
    });
    lib.disposables.push(crystalMat);

    [-1, 1].forEach((side) => {
      const c1Geo = new THREE.BoxGeometry(headSize * 0.14, headSize * 0.38, headSize * 0.14);
      const c1 = new THREE.Mesh(c1Geo, crystalMat);
      c1.position.set(side * headSize * 0.32, headSize * 1.15, headSize * 0.05);
      c1.rotation.set(0.1, side * 0.2, -side * 0.35);
      hornGroup.add(c1);

      const c2Geo = new THREE.BoxGeometry(headSize * 0.1, headSize * 0.24, headSize * 0.1);
      const c2 = new THREE.Mesh(c2Geo, crystalMat);
      c2.position.set(side * headSize * 0.44, headSize * 1.04, -headSize * 0.08);
      c2.rotation.set(-0.2, side * 0.4, -side * 0.6);
      hornGroup.add(c2);

      lib.disposables.push(c1Geo, c2Geo);
    });
  } else if (type === 'tesla_antennae') {
    // CẶP ĂNG-TEN THU LÔI ĐIỆN TỪ KIM LOẠI
    const metalMat = new THREE.MeshStandardMaterial({ color: '#e2e8f0', metalness: 0.9, roughness: 0.2 });
    const glowMat = new THREE.MeshBasicMaterial({ color: hornColor || '#facc15' });
    lib.disposables.push(metalMat, glowMat);

    [-1, 1].forEach((side) => {
      const rodGeo = new THREE.CylinderGeometry(headSize * 0.03, headSize * 0.04, headSize * 0.45, 8);
      const rod = new THREE.Mesh(rodGeo, metalMat);
      rod.position.set(side * headSize * 0.35, headSize * 1.2, 0);
      rod.rotation.set(0, 0, -side * 0.15);
      hornGroup.add(rod);

      const ballGeo = new THREE.BoxGeometry(headSize * 0.12, headSize * 0.12, headSize * 0.12);
      const ball = new THREE.Mesh(ballGeo, glowMat);
      ball.position.set(side * (headSize * 0.35 + headSize * 0.04), headSize * 1.45, 0);
      hornGroup.add(ball);

      lib.disposables.push(rodGeo, ballGeo);
    });
  } else if (type === 'emerald_horns') {
    // SỪNG HOÀNG KIM NẠM NGỌC LỤC BẢO
    const goldMat = new THREE.MeshStandardMaterial({ color: '#f59e0b', metalness: 0.9, roughness: 0.2 });
    const gemMat = new THREE.MeshStandardMaterial({ color: '#10b981', roughness: 0.15, metalness: 0.8 });
    lib.disposables.push(goldMat, gemMat);

    [-1, 1].forEach((side) => {
      const hGeo = new THREE.BoxGeometry(headSize * 0.14, headSize * 0.32, headSize * 0.14);
      const hMesh = new THREE.Mesh(hGeo, goldMat);
      hMesh.position.set(side * headSize * 0.34, headSize * 1.12, 0);
      hMesh.rotation.set(0.1, 0, -side * 0.3);
      hornGroup.add(hMesh);

      const gemGeo = new THREE.BoxGeometry(headSize * 0.1, headSize * 0.18, headSize * 0.1);
      const gemMesh = new THREE.Mesh(gemGeo, gemMat);
      gemMesh.position.set(side * headSize * 0.42, headSize * 1.28, 0.02);
      gemMesh.rotation.set(0.2, 0, -side * 0.45);
      hornGroup.add(gemMesh);

      lib.disposables.push(hGeo, gemGeo);
    });
  } else if (type === 'elder_horns') {
    // SỪNG CỔ XƯA TRƯỞNG LÃO (SỪNG RẠN NỨT, PHONG TRẦN, UỐN CONG CỔ KÍNH)
    const hornCanvas = document.createElement('canvas');
    hornCanvas.width = 256;
    hornCanvas.height = 256;
    const hctx = hornCanvas.getContext('2d');

    // Nền sừng ngà xám phong trần
    hctx.fillStyle = hornColor || '#d6d3d1';
    hctx.fillRect(0, 0, 256, 256);

    // Các đốt vân ngấn sừng niên đại
    hctx.fillStyle = 'rgba(87, 83, 78, 0.35)';
    for (let r = 0; r < 8; r++) {
      hctx.fillRect(0, r * 32, 256, 8);
    }

    // Các vết rạn nứt cổ kính thời gian
    hctx.strokeStyle = '#44403c';
    hctx.lineWidth = 2.5;
    const hornCracks = [
      [
        [30, 10],
        [50, 60],
        [40, 120],
        [65, 180],
        [55, 240]
      ],
      [
        [120, 20],
        [140, 80],
        [130, 150],
        [150, 220]
      ],
      [
        [210, 5],
        [195, 75],
        [215, 140],
        [200, 210],
        [220, 250]
      ]
    ];
    hornCracks.forEach((hc) => {
      hctx.beginPath();
      hc.forEach((pt, i) => (i === 0 ? hctx.moveTo(pt[0], pt[1]) : hctx.lineTo(pt[0], pt[1])));
      hctx.stroke();
    });

    const hornTex = new THREE.CanvasTexture(hornCanvas);
    hornTex.colorSpace = THREE.SRGBColorSpace;

    const elderMat = new THREE.MeshStandardMaterial({
      map: hornTex,
      roughness: 0.88,
      metalness: 0.12
    });
    const ringMat = new THREE.MeshStandardMaterial({
      color: '#57534e',
      roughness: 0.9,
      metalness: 0.2
    });
    lib.disposables.push(hornTex, elderMat, ringMat);

    [-1, 1].forEach((side) => {
      // 1. Gốc sừng (Root Base): vươn chéo lên và hướng ra trước
      const bGeo = new THREE.BoxGeometry(headSize * 0.18, headSize * 0.34, headSize * 0.18);
      const base = new THREE.Mesh(bGeo, elderMat);
      base.position.set(side * headSize * 0.36, headSize * 1.06, headSize * 0.05);
      base.rotation.set(0.2, side * 0.15, -side * 0.35);
      hornGroup.add(base);

      // Vòng ngấn gốc sừng
      const ringGeo = new THREE.BoxGeometry(headSize * 0.2, headSize * 0.06, headSize * 0.2);
      const ring = new THREE.Mesh(ringGeo, ringMat);
      ring.position.set(side * headSize * 0.36, headSize * 1.1, headSize * 0.05);
      ring.rotation.set(0.2, side * 0.15, -side * 0.35);
      hornGroup.add(ring);

      // 2. Thân giữa (Mid-arch): uốn cong ngoặt về phía sau gáy
      const mGeo = new THREE.BoxGeometry(headSize * 0.15, headSize * 0.32, headSize * 0.15);
      const mid = new THREE.Mesh(mGeo, elderMat);
      mid.position.set(side * headSize * 0.45, headSize * 1.25, -headSize * 0.1);
      mid.rotation.set(-0.55, side * 0.25, -side * 0.5);
      hornGroup.add(mid);

      // 3. Khúc cua sừng trên (Upper Curve): uốn vòm lên cao phong trần
      const uGeo = new THREE.BoxGeometry(headSize * 0.12, headSize * 0.28, headSize * 0.12);
      const upper = new THREE.Mesh(uGeo, elderMat);
      upper.position.set(side * headSize * 0.52, headSize * 1.38, -headSize * 0.28);
      upper.rotation.set(-0.85, side * 0.2, -side * 0.35);
      hornGroup.add(upper);

      // 4. Chóp sừng vuốt nhọn (Tip): vểnh cong nhẹ ra ngoài uy nghi
      const tGeo = new THREE.BoxGeometry(headSize * 0.08, headSize * 0.24, headSize * 0.08);
      const tip = new THREE.Mesh(tGeo, elderMat);
      tip.position.set(side * headSize * 0.56, headSize * 1.48, -headSize * 0.46);
      tip.rotation.set(-1.1, side * 0.1, -side * 0.2);
      hornGroup.add(tip);

      // Mấu gai nứt phụ phong trần
      const spurGeo = new THREE.BoxGeometry(headSize * 0.06, headSize * 0.12, headSize * 0.06);
      const spur = new THREE.Mesh(spurGeo, elderMat);
      spur.position.set(side * headSize * 0.48, headSize * 1.32, -headSize * 0.02);
      spur.rotation.set(0.3, side * 0.2, -side * 0.6);
      hornGroup.add(spur);

      lib.disposables.push(bGeo, ringGeo, mGeo, uGeo, tGeo, spurGeo);
    });
  }

  return hornGroup;
}
